import React from 'react';
import { Link } from 'react-router-dom';
import {
  CheckCircle as CheckCircleIcon,
  RadioButtonUnchecked as PendingIcon,
} from '@mui/icons-material';

const ProfileCompletionPanel = ({ completion }) => {
  if (!completion) {
    return null;
  }

  const { percent, is_complete: isComplete, items } = completion;

  return (
    <section className="creator-profile-completion border border-gray-200 rounded-lg p-4 mb-6">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between mb-4">
        <div>
          <h3 className="text-lg font-semibold text-gray-900">Complétion du profil public</h3>
          <p className="text-sm text-gray-600 mt-1">
            {isComplete
              ? 'Votre fiche artisan est prête à être découverte.'
              : 'Complétez les éléments ci-dessous pour une fiche artisan attractive.'}
          </p>
        </div>
        <div className="text-right">
          <span className="text-2xl font-bold text-blue-700">{percent}%</span>
          <p className="text-xs text-gray-500">
            {completion.completed_count}/{completion.total_count} critères
          </p>
        </div>
      </div>

      <div className="h-2 w-full rounded-full bg-gray-100 overflow-hidden mb-4">
        <div
          className={`h-full rounded-full transition-all duration-300 ${
            isComplete ? 'bg-green-500' : 'bg-blue-600'
          }`}
          style={{ width: `${percent}%` }}
          role="progressbar"
          aria-valuenow={percent}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-label="Progression du profil"
        />
      </div>

      <ul className="space-y-2">
        {items.map((item) => (
          <li key={item.id} className="flex items-start gap-2 text-sm">
            {item.completed ? (
              <CheckCircleIcon fontSize="small" className="text-green-600 mt-0.5" />
            ) : (
              <PendingIcon fontSize="small" className="text-gray-400 mt-0.5" />
            )}
            <span className={item.completed ? 'text-gray-700' : 'text-gray-900 font-medium'}>
              {item.label}
            </span>
            {!item.completed && item.id === 'active_product' && (
              <Link to="/products" className="ml-auto text-blue-600 hover:text-blue-800 whitespace-nowrap">
                Ajouter un produit
              </Link>
            )}
          </li>
        ))}
      </ul>
    </section>
  );
};

export default ProfileCompletionPanel;
